/* eslint-disable react-hooks/exhaustive-deps */
import { Paper } from "@mui/material";
import { Location } from 'history'
import { FC, useCallback, useEffect, useMemo, useState } from "react"
import { useHistory, Prompt } from "react-router-dom";
import { VALOR_MULTIPLO_CABO, NOME_CLIENTE_MAX_LENGTH } from "src/components/projetos/constants";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { ValidateUtil } from "src/framework/commons/ValidateUtil";
import { apiNoLoading, STATUS_CODE } from "src/framework/providers/api";
import { useObservable } from "src/framework/store/storeUtil";
import { EquipeType } from "src/providers/cadastros/ContaProvider/types";
import { ProjetosProvider } from "src/providers/ProjetosProvider";
import { getCidades, getEstados, getDistribuidoresPorTipoDeConta, getRevendas, distribuidoresPorTipoDeConta$, revendas$, getEstadosServico, getRegioes, regioes$, estadosServico$, getDistribuidores, verificarSegmentoConta } from "src/store/global.store";
import { Regiao } from "src/types";
import { ListUtil } from "src/framework/commons/ListUtil";
import { getLatLng } from "react-places-autocomplete";
import { debounce } from "lodash";
import { notifierStore } from "src/framework/store/NotifierStore";
import { ContaProvider } from "src/providers/cadastros/ContaProvider";
import { ComponenteProvider } from "src/providers/estoque/ComponenteProvider";
import { manualLoading$ } from "src/framework/store/ApiEvents";
import { oldEstruturasHibrido$, useProjetosHibridoStore } from "src/store/vendas/projetos/hibrido/hibrido.store";
import { FormProjetoHibridoType } from "src/store/vendas/projetos/hibrido/hibrido.types";
import { ListagemItem, ModuloListagem, ProjetoTipoType } from "../types";
import { FormDadosHibrido } from "./FormDadosHibrido";
import { InformationDrawerHibrido } from "../InformationDrawerHibrido";
import { buscarEstruturasPorModulo } from "../dimensionados_hibrido/utils/buscarEstruturasPorModulo";
import { elSemEstrutura } from "../dimensionados_hibrido/containers/modalEditarEstruturas";
import { calcularEstruturas } from "../dimensionados_hibrido/utils/calcularEstruturas";
import { calcularAcessorios } from "../dimensionados_hibrido/utils/calcularAcessorios";
import { ACESSORIOS_MANTIDOS_EDICAO } from "../dimensionados_hibrido/containers/solucao";
import { DEFAULT_PROJETO_HIBRIDO } from "src/store/vendas/projetos/hibrido/hibrido.constants";
import { ProjetosHibridoProvider } from "src/providers/ProjetosHibridoProvider";
import { calcularPotenciaEquipamentosHibrido } from "../utils/calcularPotenciaEquipamentosHibrido";
import { DecimalUtil } from "src/framework/commons/DecimalUtils";
import { safeGeocodeByAddress } from "src/framework/commons/MapsUtil";

interface GetLatLngFromAddressType {
  cep: string;
  cidadeNome: string;
  estadoId: string;
}

const TITULO_MAX_LENGTH = 100

const projetosProvider = new ProjetosProvider();
const projetosHibridoProvider = new ProjetosHibridoProvider();
const contasProvider = new ContaProvider();
const componenteProvider = new ComponenteProvider();

const initLoad = async () => {
  await Promise.all([
    getEstados(),
    getRegioes(),
    getCidades(),
    getDistribuidores(),
    getDistribuidoresPorTipoDeConta(),
    getRevendas(),
    getEstadosServico({ force: true }),
  ])
}

export const ProjetosFormInicialHibrido: FC = () => {
  const projetosHibridoState = useProjetosHibridoStore(store => store.state.data)
  const projetosHibridoModalsState = useProjetosHibridoStore(store => store.state.modals)
  const projetosHibridoActions = useProjetosHibridoStore(store => store.actions)

  const history = useHistory<{ allowAccess?: boolean; noReset?: boolean; done?: boolean; tipo?: ProjetoTipoType }>();
  const regioes = useObservable(regioes$)
  const revendasState = useObservable(revendas$);
  const estadosServico = useObservable(estadosServico$);

  const [errorState, setErrorState] = useState<string[]>([]);
  const [checkSegmentoConta, setCheckSegmentoConto] = useState<boolean>(false);
  const [distribuidorRevendaUsuario, setDistribuidorRevendaUsuario] = useState<any>(null);
  const [oldFormState] = useState(DEFAULT_PROJETO_HIBRIDO)
  const oldEstruturasHibrido = useObservable(oldEstruturasHibrido$);
  
  const canNavigate = useCallback((location: Location | null = null)=>{
    const allowedLocations = ['/projetos/.*/novo', 'edicao$', 'clonar$']
    const localLocation = location || history.location

    const loc = localLocation as Location<{ done: boolean }>

    return loc.state?.done || allowedLocations.some(item => {
      return loc?.pathname.match(new RegExp(item))
    })
  },[history.location])

  useEffect(() => {
    return () => {
      if (!canNavigate()) {
        projetosHibridoActions.reset()
      }
    }
  },[canNavigate, history, projetosHibridoActions])

  const init = useCallback(()=>{
    const _distribuidorRevendaUsuario: any = LocalStorage.get("solar.userExtraInfo", true)
    setDistribuidorRevendaUsuario(_distribuidorRevendaUsuario)
  },[])

  useEffect(() => {
    initLoad().then(() => {
      init()
    })
  }, [init]);

  useEffect(()=>{
    if (!checkSegmentoConta) {
      if (projetosHibridoState?.distribuidor_id) {
        verificarSegmentoConta({ 
          goBack: true,
          segmento: projetosHibridoState?.segmento || 'on', 
          revendaId: projetosHibridoState?.revenda_id || projetosHibridoState?.revenda?.id || undefined, 
          distribuidorId: projetosHibridoState?.distribuidor_id || projetosHibridoState?.distribuidor?.id || undefined
        });
        setCheckSegmentoConto(true);
      } else if (!projetosHibridoState?.isEdit) {
        verificarSegmentoConta({ segmento: 'on', goBack: true });
        setCheckSegmentoConto(true);
      }
    }
  },[projetosHibridoState, checkSegmentoConta]);

  const onClickNext = useCallback((state: FormProjetoHibridoType)=>{
    projetosHibridoActions.changeValue(state)

    const urlsFromTipo: {[index: string]: string} = {
      dimensionado: '/projetos/hibrido/dimensionados/novo',
    }
    
    const urlsFromTipoEdicao: {[index: string]: string} = {
      dimensionado: `/projetos/${state.id}/hibrido/dimensionados/edicao`,
    }

    const urlsFromTipoClonar: {[index: string]: string} = {
      dimensionado: `/projetos/${state.id}/hibrido/dimensionados/clonar`,
    }


    if (urlsFromTipo[state.tipo]) {
      if (state.clonar_projeto) {
        history.push(urlsFromTipoClonar[state.tipo], { allowAccess: true })
        return
      }
      
      if (state.isEdit) {
        history.push(urlsFromTipoEdicao[state.tipo], { allowAccess: true })
        return
      }
      
      history.push(urlsFromTipo[state.tipo], { allowAccess: true })
    }
  },[history, projetosHibridoActions])

  const validate = useCallback(() => {
    const _errorState = [...errorState]
    const messages: string[] = [];

    const data = {...projetosHibridoState}

    if (!data?.cliente_proposta){
      messages.push("O campo nome do cliente é obrigatório");
      _errorState.push("cliente_proposta")
    }

    if (data.cliente_proposta && data.cliente_proposta.length > NOME_CLIENTE_MAX_LENGTH) {
      messages.push(`O campo nome do cliente deve ter no máximo ${NOME_CLIENTE_MAX_LENGTH} caracteres`);
      _errorState.push("cliente_proposta")
    }


    if (data?.titulo && data?.titulo?.length > TITULO_MAX_LENGTH) {
      messages.push("O campo título deve ter no máximo 100 caracteres");
      _errorState.push("titulo")
    }

    if (!data?.cidade) {
      messages.push("O campo cidade é obrigatório");
      _errorState.push("cidade_id")
    }

    if (!data?.distribuidor_id && !data?.distribuidor?.id) {
        messages.push("O campo distribuidor é obrigatório");
        _errorState.push("distribuidor_id")
    }



    if(data?.email_proposta){
      if (!ValidateUtil.isValidEmail(data?.email_proposta)) {
        messages.push("E-mail inválido");
        _errorState.push("email_proposta")
      }else{
        ListUtil.removeItem(_errorState, "email_proposta")
      }
    }else{
      ListUtil.removeItem(_errorState, "email_proposta")
    }

    if (messages.length > 0) {
      setErrorState(_errorState)
      notifierStore.setNotifier({
          title: "Aviso",
          content: messages,
          timeOut: 3500,
          onClose: () => {
              notifierStore.setOpen(false)
          }
      })
      notifierStore.setOpen(true)
    }

    return messages.length === 0;
  }, [errorState, projetosHibridoState])

  const mostrarOpcaoServico = useMemo(()=>{
    if (!projetosHibridoState?.estado?.id) return true;
    const reg = regioes?.data || []
    const estadosPermitemServico: string[] = (estadosServico?.data || []).map((item: any) => item.regiao_id)
    const currentRegioes: string[] = reg.filter((item: Regiao) => {
      if (!item.estados || item.estados.length === 0) return false;
      const ids = item.estados.map((estado: any) => estado.estado_id)
      return ids.includes(projetosHibridoState.estado?.id)
    }).map((item: any) => item.id)
    return estadosPermitemServico.some(item => {
      if (currentRegioes.includes(item)) return true;
      return false;
    })
  },[regioes, projetosHibridoState?.estado, estadosServico])

  const captureData = useCallback(async(data: any) => {
    if (!validate()) return

    const state = { ...data };

    const distribuidores = distribuidoresPorTipoDeConta$.getValue();

    if (state?.distribuidor === undefined) {
      const idxDistribuidor = distribuidores.data.findIndex((d: any) => d.id === distribuidorRevendaUsuario?.distribuidor_id)
      if (idxDistribuidor > -1) {
        state.distribuidor = distribuidores.data[idxDistribuidor]
      }
    }

    if (state?.revenda === undefined) {
      const idxRevenda = revendasState?.data.findIndex((d: any) => d.id === distribuidorRevendaUsuario?.revenda_id)
      
      if (idxRevenda > -1) {
        state.revenda = revendasState.data[idxRevenda]
      } else {
        if (distribuidorRevendaUsuario?.revenda_id && distribuidorRevendaUsuario?.revenda_nome && distribuidorRevendaUsuario?.revenda_cnpj_cpf) {
          state.revenda = {
            id: distribuidorRevendaUsuario.revenda_id,
            nome: distribuidorRevendaUsuario.revenda_nome,
            cnpj_cpf: distribuidorRevendaUsuario.revenda_cnpj_cpf,
          }
        }
      }
    }

    const cpfCnpjDistribuidor = state?.distribuidor?.cnpj_cpf;

    if (!state?.codigo_venda) {
      if (cpfCnpjDistribuidor === "" || cpfCnpjDistribuidor === undefined || cpfCnpjDistribuidor === null) {
        notifierStore.setNotifier({
            title: "Aviso!!!",
            content: "Distribuidor não informado ou CNPJ inválido!",
            timeOut: 3000,
            onClose: () => {
                notifierStore.setOpen(false);
            }
        })
        notifierStore.setOpen(true);
        return;
      }
    }

    const hasRevenda = !!state?.revenda;

    if ((oldFormState?.distribuidor?.id !== state?.distribuidor?.id) || (oldFormState?.distribuidor?.id === state?.distribuidor?.id && hasRevenda && oldFormState?.revenda?.id !== state?.revenda?.id)) {
      let codigoDistribuidorRevenda = state?.distribuidor?.id;
      
      if (hasRevenda) {
          codigoDistribuidorRevenda = state?.revenda?.id;
      }

      const responseEquipe: EquipeType | null = await contasProvider.getEquipe(codigoDistribuidorRevenda, state.segmento, apiNoLoading);

      state.ev_id = responseEquipe?.ev_id;
      state.supervisor_id = responseEquipe?.supervisor_id;
      state.assistente_id = responseEquipe?.assistente_id;
    }
    
    state.distribuidor_id = state?.distribuidor?.id;
    state.cidade_id = state?.cidade?.id;
    state.estado_id = state?.estado?.id;
    
    return state;
  },[distribuidorRevendaUsuario, revendasState, oldFormState?.distribuidor?.id, oldFormState?.revenda?.id, validate])

  useEffect(() => {
    if (distribuidorRevendaUsuario && !projetosHibridoState?.distribuidor?.id) {
          const projetoPayload: Partial<FormProjetoHibridoType> = {}

          if (!distribuidorRevendaUsuario.isIntelbras) {
            Object.assign<Partial<FormProjetoHibridoType>, Partial<FormProjetoHibridoType>>(projetoPayload, { distribuidor_id: distribuidorRevendaUsuario?.distribuidor_id })

            const distribuidores = distribuidoresPorTipoDeConta$.getValue().data
            const distribuidorIdx = distribuidores.findIndex((d) => d.id === projetosHibridoState.distribuidor_id)
            if (distribuidorIdx > -1) {
              Object.assign<Partial<FormProjetoHibridoType>, Partial<FormProjetoHibridoType>>(projetoPayload, { distribuidor: distribuidores[distribuidorIdx] })
            }

            if (distribuidorRevendaUsuario?.revenda_id) {
              Object.assign<Partial<FormProjetoHibridoType>, Partial<FormProjetoHibridoType>>(projetoPayload, { revenda_id: distribuidorRevendaUsuario?.revenda_id })
                const revendas = revendas$.getValue().data;
                const revendaIdx = revendas.findIndex((r) => r.id === projetosHibridoState.revenda_id)
                if (revendaIdx > -1) {
                  Object.assign<Partial<FormProjetoHibridoType>, Partial<FormProjetoHibridoType>>(projetoPayload, { revenda: revendas[revendaIdx] })
                }
            }

            projetosHibridoActions.changeValue(projetoPayload)

            verificarSegmentoConta({ 
              goBack: true,
              segmento: 'on', 
              revendaId: distribuidorRevendaUsuario?.revenda_id || undefined, 
              distribuidorId: distribuidorRevendaUsuario?.distribuidor_id || undefined
            });
          }
      }

  }, [distribuidorRevendaUsuario, projetosHibridoActions, projetosHibridoState.distribuidor_id, projetosHibridoState.revenda_id, projetosHibridoState?.distribuidor?.id]);

  const getLatLngFromAddress = useCallback((payload: GetLatLngFromAddressType) => {
    const { cidadeNome, estadoId } = payload;
    if (!estadoId || !cidadeNome) return;
    const endereco = `, , , ${cidadeNome}, ${estadoId}, `
    safeGeocodeByAddress(endereco)
    .then(res => getLatLng(res[0])).then(async ({lat, lng}) => {
      projetosHibridoActions.changeValue({ latitude: lat, longitude: lng })
    }).catch(err => {
      projetosHibridoActions.changeValue({ latitude: 0, longitude: 0 })
      notifierStore.setNotifier({
          title: "Aviso",
          content: "Não foi possível obter a localização a partir do endereço fornecido.",
          timeOut: 3500,
          onClose: () => {
              notifierStore.setOpen(false)
          }
      })
      notifierStore.setOpen(true);
    })
  },[projetosHibridoActions])

  const getLatLngFromAddressDebounced = useCallback(
    debounce((payload: GetLatLngFromAddressType) => {
      getLatLngFromAddress(payload)
    }, 800),
    []
  );

  useEffect(() => {
    if (!projetosHibridoState?.estado?.id || !regioes?.data || regioes?.data.length === 0) return;

    const localRegioes = regioes.data || []
    const projetosRegioes = localRegioes.filter((regiao: any) => {
      const estadosList = regiao.estados || []
      const estados = estadosList.map((item: any) => item.estado_id)
      return estados.includes(projetosHibridoState?.estado?.id)
    })

    projetosHibridoActions.changeValue({
      regioes: projetosRegioes.map((item: Regiao) => item.id),
    })
  },[projetosHibridoActions, projetosHibridoState?.estado?.id, regioes?.data])

  useEffect(() => {
    if (!projetosHibridoState.regioes.length) return;

    projetosHibridoActions.changeValue({ listagem_baterias_status: false })

    componenteProvider.buscarBateriasPorRegiao(
      projetosHibridoState.regioes,
      undefined,
      true

    ).then(response => {
      
      if (response.statusCode !== STATUS_CODE.OK) {
        notifierStore.setNotifier({
          content: response.message || 'Erro ao buscar baterias.',
          onClose: () => notifierStore.setOpen(false),
          timeOut: 4000,
          title: "Atenção"
        })

        notifierStore.setOpen(true)
        return;
      }

      projetosHibridoActions.changeValue({ listagem_baterias_status: true })
      projetosHibridoActions.addBaterias(response.data)
    }).catch((err) => {
      //TODO: Verificar tratamento de erro
    })

  }, [projetosHibridoState.regioes])

  useEffect(()=>{
    const moduloSelecionado = projetosHibridoState.modulo_selecionado;
    const potenciaDesejada = projetosHibridoState.potencia_desejada_kw;

    if (!moduloSelecionado?.componente_id || !Number(potenciaDesejada || 0)) return;

    projetosHibridoActions.changeLoadingState('calculoModulos', true) 

    debouncedCalculoQtdModulos({
      moduloSelecionado: moduloSelecionado,
      potenciaDesejada: potenciaDesejada,
    })
  },[projetosHibridoState.modulo_selecionado?.componente_id, projetosHibridoState.potencia_desejada_kw])

  useEffect(() => {
    if (!projetosHibridoState.regioes.length || !projetosHibridoState.modulo_selecionado) return;
    const moduloSelecionado = projetosHibridoState?.modulo_selecionado;
    const potenciaDeModulosKw = (Number(moduloSelecionado.quantidade || 0) * Number(moduloSelecionado.potencia || 0)) / 1000
    
    const isFiname = moduloSelecionado.finame || false;
    
    if (potenciaDeModulosKw > 0 && moduloSelecionado?.componente_id) {
      
      if (isFiname) {
        projetosHibridoActions.syncFileiras(undefined, undefined, undefined, false);
      }

      projetosHibridoActions.changeLoadingState('listagemEstruturas', true) 
      debouncedBuscaEstruturas({
        potencia: DecimalUtil.toFixed(potenciaDeModulosKw, 2),
        moduloId: moduloSelecionado.componente_id,
        regioes: projetosHibridoState.regioes
      })
    }
  }, [projetosHibridoState.modulo_selecionado, projetosHibridoState.regioes])

  const calculaQtdModulos = useCallback((payload: { idModuloSelecionado: any, potenciaDesejada: number })=>{
    return projetosProvider.buscarQuantidadeDeModulos(payload.idModuloSelecionado, payload.potenciaDesejada, "on", apiNoLoading)
  },[])

  const debouncedCalculoQtdModulos = useCallback(
    debounce((payload: { moduloSelecionado: Omit<ModuloListagem, "selecionado"> | null; potenciaDesejada: number }) => {
      calculaQtdModulos({
        idModuloSelecionado: payload.moduloSelecionado?.componente_id,
        potenciaDesejada: payload.potenciaDesejada,
      }).then(response => {
        const input = {
          modulo_selecionado: payload.moduloSelecionado ? {
            ...(payload.moduloSelecionado || {}),
            quantidade: response.data.quantidade || 0,
          } : null
        }

        if (Number(payload.moduloSelecionado?.quantidade || 0) !== Number(response.data.quantidade || 0)) {
          Object.assign(input, { recalcular: true })
        }

        projetosHibridoActions.changeValue(input)
        projetosHibridoActions.changeLoadingState('calculoModulos', false) 
      }).catch(() => {
        projetosHibridoActions.changeLoadingState('calculoModulos', false) 
      })
    }, 800), []
  )

  const debouncedBuscaEstruturas = useCallback(
    debounce((payload: { moduloId: number; potencia: number, regioes: number[] }) => {
      buscarEstruturasPorModulo({
        moduloId: payload.moduloId,
        potencia: payload.potencia,
        regioesId: payload.regioes,
      }).then(response => {
        projetosHibridoActions.addEstruturas(response);
        projetosHibridoActions.changeLoadingState('listagemEstruturas', false)
      }).catch(() => {
        projetosHibridoActions.changeLoadingState('listagemEstruturas', false)
      })
    }, 800), []
  )
  
  const debouncedBuscaModulos = useCallback(
    debounce((payload: { regioes: number[]; potenciaDesejada: number }) => {
      buscaModulos(payload.regioes, payload.potenciaDesejada)
    }, 800),
    []
  );

  const buscaModulos = useCallback((regioes: number[], potenciaDesejada: number)=>{
    componenteProvider.buscarModulosPorRegiao(
      regioes.map(String), 
      Number(potenciaDesejada),
      undefined,
      undefined,
      undefined,
      undefined,
      "on",
    ).then(response => {
      projetosHibridoActions.addModulos(response)
      projetosHibridoActions.changeLoadingState('listagemModulos', false)
    }).catch((err) => {
      projetosHibridoActions.changeLoadingState('listagemModulos', false)
    })
  },[])

  useEffect(() => {
    if (!projetosHibridoState.potencia_desejada_kw || !projetosHibridoState.potencia_desejada_w || !projetosHibridoState.regioes.length) return;

    projetosHibridoActions.changeLoadingState('listagemModulos', true)

    debouncedBuscaModulos({
      potenciaDesejada: projetosHibridoState.potencia_desejada_kw,
      regioes: projetosHibridoState.regioes,
    })
  }, [projetosHibridoState.potencia_desejada_kw, projetosHibridoState.regioes])

  // useEffect(()=>{
  //   if (projetosOffGridState.estrutura_selecionada) {
  //     const estruturaSelecionada = projetosOffGridState.estrutura_selecionada?.id ? projetosOffGridState.estruturas?.find(item => item.id === projetosOffGridState.estrutura_selecionada?.id && item.estruturas_grupo_id === projetosOffGridState.estrutura_selecionada?.estruturas_grupo_id) : true;
  //     const alterouValores = projetosOffGridState?.isTrocaUf || projetosOffGridState?.isTrocaModulo || projetosOffGridState?.isTrocaPotencia;
  //     const estruturaNaoEditada = !projetosOffGridState?.estrutura_selecionada?.editada && !projetosOffGridState.isEdit;
  //     const semEstruturaGrupo = !projetosOffGridState.estrutura_selecionada?.grupos?.length && projetosOffGridState.isEdit;
  //     const resultEstrutura = projetosOffGridState?.todas_estruturas?.find(estrutura => estrutura.id === projetosOffGridState.estrutura_selecionada?.id && estrutura?.grupos?.map(grupo => grupo?.id)?.includes(projetosOffGridState.estrutura_selecionada?.estruturas_grupo_id));

  //     if (!estruturaSelecionada && (estruturaNaoEditada || alterouValores || semEstruturaGrupo || !resultEstrutura)) {
  //       projetosOffGridActions.changeValue({ estrutura_selecionada: null })
  //       projetosOffGridActions.changeValidationsValue({ estrutura: { helper: "Estrutura anterior removida: não permitido para esta UF", status: false } })
  //     } else {
  //       projetosOffGridActions.changeValidationsValue({ estrutura: { helper: "", status: true } })

  //       const estruturas = projetosOffGridState.estruturas;
  //       const listaEstruturas =  [...estruturas];
  //       const estruturasIds = estruturas?.map(estrutura => estrutura.id);
  //       const estruturasGrupoIds = estruturas?.map(estrutura => estrutura.estruturas_grupo_id);
  //       if (projetosOffGridState?.estrutura_selecionada?.id && (!estruturasIds?.includes(projetosOffGridState?.estrutura_selecionada?.id) || (estruturasIds?.includes(projetosOffGridState?.estrutura_selecionada?.id) && !estruturasGrupoIds?.includes(projetosOffGridState?.estrutura_selecionada?.estruturas_grupo_id)))) {
  //         listaEstruturas.push(projetosOffGridState.estrutura_selecionada);
  //         projetosOffGridActions.changeValue({ estruturas: listaEstruturas });
  //       }
  //     }
  //   } else if (projetosOffGridState.isEdit && !projetosOffGridValidationsStoreState?.estrutura?.helper) {
  //     projetosOffGridActions.changeValidationsValue({ estrutura: { helper: "", status: false } })
  //   }
  // },[projetosOffGridActions, projetosOffGridState.estrutura_selecionada, projetosOffGridState.estruturas, projetosOffGridState?.isTrocaUf, projetosOffGridState?.isTrocaModulo, projetosOffGridState?.isTrocaPotencia, projetosOffGridState?.isEdit, projetosOffGridValidationsStoreState?.estrutura?.helper, projetosOffGridState?.todas_estruturas])

  useEffect(()=>{
    if (!projetosHibridoState.cidade?.nome || !projetosHibridoState.estado?.id) return;

    getLatLngFromAddressDebounced({
      cep: '',
      cidadeNome: projetosHibridoState.cidade?.nome || '',
      estadoId: projetosHibridoState.estado?.id || '',
    })
  },[getLatLngFromAddressDebounced, projetosHibridoState.cidade, projetosHibridoState.estado])

  const comparaEstruturas = (antiga: ListagemItem[], atual: ListagemItem[])=>{
      if (antiga.length !== atual.length) return false;
      return antiga.every(itemAntigo => {
        const itemAtual = atual.find(a => a.componente_id === itemAntigo.componente_id);
        return itemAtual?.quantidade === itemAntigo?.quantidade;
      });
  }
  return (
      <>
      <Paper elevation={0}>
        <FormDadosHibrido
          formState={projetosHibridoState}
          onChangeValue={(newState: any) => projetosHibridoActions.changeValue(newState)}
          errorState={errorState}
          onChangeError={(newErrorState: any) => setErrorState(newErrorState)}
          distribuidorRevendaUsuario={distribuidorRevendaUsuario}
          onClickNext={async() => {
            manualLoading$.next(true)

            const result: typeof projetosHibridoState = await captureData(projetosHibridoState)
            if (!result) {
              manualLoading$.next(false)
              return
            };
            const state = { ...result } 

            state.codigo_venda = result.codigo_venda
            state.recebe_servico = mostrarOpcaoServico

            const estruturaPrimeiraFileira = projetosHibridoState.fileiras?.[0]?.tipo_estrutura

            const qtdModulosResult = await projetosProvider.buscarQuantidadeDeModulos(projetosHibridoState.modulo_selecionado?.componente_id || 0, projetosHibridoState.potencia_desejada_kw || 0, projetosHibridoState.segmento || '')

            if (qtdModulosResult.statusCode !== STATUS_CODE.OK) {
              notifierStore.setNotifier({
                content: qtdModulosResult.message || "Erro ao calcular quantidade de módulos.",
                onClose: () => notifierStore.setOpen(false),
                timeOut: 4000,
                title: "Atenção"
              })

              manualLoading$.next(false)
              notifierStore.setOpen(true)
              return;
            }

            let qtdModulos = qtdModulosResult.data?.quantidade || 0
            
            if (state.modulo_selecionado) {
              state.modulo_selecionado = {
                ...state.modulo_selecionado,
                quantidade: qtdModulos,
              }
            }

            const solucaoCalculadaResponse = await projetosHibridoProvider.calcularSolucao({
              regioes: projetosHibridoState.regioes,
              tensao_saida: projetosHibridoState.tensao_saida?.id || 0,
              tipo_conexao: projetosHibridoState.tipo_ligacao?.id || 0,
              tipo_bateria: projetosHibridoState.tipo_bateria?.id || null,
              taxa_descarga: projetosHibridoState.taxa_descarga?.id || null,
              potencia_desejada: projetosHibridoState.potencia_desejada_kw,
              carga_equipamentos: projetosHibridoState.total_carga_equipamentos_kw,
              potencia_equipamentos: calcularPotenciaEquipamentosHibrido(projetosHibridoState.cargas_prioritarias || []).total_kva,
              quantidade_modulos: state.modulo_selecionado?.quantidade || 0,
              modulo_id: projetosHibridoState.modulo_selecionado?.componente_id || null,
            })

            if (solucaoCalculadaResponse.statusCode !== STATUS_CODE.OK) {
              notifierStore.setNotifier({
                content: solucaoCalculadaResponse.message,
                onClose: () => notifierStore.setOpen(false),
                timeOut: 4000,
                title: "Atenção"
              })
  
              manualLoading$.next(false)
              notifierStore.setOpen(true)
              return;
            }

            const calculoAcessorios = await calcularAcessorios({
              moduloId: state.modulo_selecionado?.componente_id || 0,
              regioes: projetosHibridoState.regioes,
              inversores: solucaoCalculadaResponse.data?.inversores.length ? solucaoCalculadaResponse.data?.inversores : [], //TODO: Ajustar após ter calculo de inversores
              quantidade_modulos: state.modulo_selecionado?.quantidade || 0,
              projetoFiname: state.modulo_selecionado?.finame || false,
            })

            if (calculoAcessorios.statusCode !== STATUS_CODE.OK) {
              manualLoading$.next(false)
              return;
            } 

            const potenciaModulosEmWatts = state.modulo_selecionado ? (state.modulo_selecionado.quantidade * state.modulo_selecionado.potencia) : 0
            const potenciaModulosEmKiloWatts = potenciaModulosEmWatts ? DecimalUtil.toFixed(potenciaModulosEmWatts / 1000, 2) : 0
            const valorMinimoServicoResult = await projetosProvider.calcularValorMinimoServico(Number(potenciaModulosEmKiloWatts || 0), apiNoLoading);
            if (valorMinimoServicoResult.statusCode !== STATUS_CODE.OK) {
              notifierStore.setNotifier({
                content: valorMinimoServicoResult.message || "Erro ao calcular valor mínimo de serviço.",
                onClose: () => notifierStore.setOpen(false),
                timeOut: 4000,
                title: "Atenção"
              })

              manualLoading$.next(false)
              notifierStore.setOpen(true)
              return;
            }
            
            delete (state as Partial<typeof state>).solucao_calculada;
            
            const oldInversores = projetosHibridoState.solucao_calculada?.inversores ? projetosHibridoState.solucao_calculada?.inversores.map(item => ({ id: item.id, quantidade: item.quantidade })).sort((a, b) => a.id - b.id) : []
            const newInversores = solucaoCalculadaResponse.data?.inversores ? solucaoCalculadaResponse.data?.inversores.map(item => ({ id: item.id, quantidade: item.quantidade })).sort((a, b) => a.id - b.id) : [];

            if (JSON.stringify(oldInversores) !== JSON.stringify(newInversores)) {
              state.recalcular = true;
            }

            if (!solucaoCalculadaResponse.data) return;
            projetosHibridoActions.addSolucaoCalculada(solucaoCalculadaResponse.data);

            const acessorios = calculoAcessorios.data || [];
            const oldAcessorios = state.acessorios || []
            if (acessorios.length > 0) {
              state.acessorios = acessorios.map(item=>{
                const oldQuantidade = oldAcessorios.find(oldItem => oldItem.componente_id === item.componente_id)?.quantidade || 0;
                const mantemAcessorio = ACESSORIOS_MANTIDOS_EDICAO.includes(item.categoria_componentes_id);
                const acessoriosSugestao = state.sugestoes.acessorios.find(acessorioSugestao => acessorioSugestao.id === item.componente_id);
                const sugestaoMudou = acessoriosSugestao?.quantidade !== item.quantidade
                
                let qtd = oldQuantidade || 0;
                const seguindoSugestao = acessoriosSugestao ? acessoriosSugestao?.quantidade === qtd : false;

                if (state.recalcular) {
                  if (mantemAcessorio) {
                    qtd = oldQuantidade || 0;
                  } else {
                    qtd = item.quantidade || 0;
                  }
                } else {
                  if (sugestaoMudou && seguindoSugestao) {
                    qtd = item.quantidade || 0;
                  }
                }

                if (item.quantidade_minima_finame > 0 && !!state.modulo_selecionado?.finame && qtd < VALOR_MULTIPLO_CABO) {
                  qtd = item.quantidade_minima_finame;
                }

                return {
                  ...item,
                  quantidade: qtd
                }
              })
            }

            state.valor_minimo_servico = valorMinimoServicoResult.data?.valor_minimo_servico || 0;

            if (estruturaPrimeiraFileira) {
              const estruturaSelecionada =  estruturaPrimeiraFileira?.value ? projetosHibridoState.estruturas_ativas?.find(item => item.id === estruturaPrimeiraFileira?.value) : elSemEstrutura;

              if (Array.isArray(state.fileiras)) {
                if (state.fileiras.length === 1) {
                  state.fileiras = state.fileiras.map(fileira => ({ ...fileira, quantidade_modulos: qtdModulos }))
                }
              }

              if (estruturaSelecionada?.id) {
                const estruturaResult = await calcularEstruturas({
                  moduloId: projetosHibridoState.modulo_selecionado?.componente_id || 0,
                  fileiras: state.fileiras,
                  inversor: '',
                  potencia: state.potencia_desejada_kw,
                  regioes: projetosHibridoState.regioes.map(Number),
                })
                oldEstruturasHibrido$.next(estruturaResult);
                if (!comparaEstruturas(oldEstruturasHibrido, estruturaResult)){
                  state.estruturas_calculadas = estruturaResult;
                }else {
                  state.estruturas_calculadas = projetosHibridoState.estruturas_calculadas || [];
                }
              } else {
                oldEstruturasHibrido$.next([])
                state.estruturas_calculadas = [];
              }
            }

            state.recalcular = false;
            state.isTrocaUf = false;
            state.isTrocaModulo = false;
            state.isTrocaPotencia = false;
            manualLoading$.next(false)
            onClickNext(state)
        }}
        />

      </Paper>
      <Prompt when={!!projetosHibridoState?.codigo_venda} message={(location) => {
        if (canNavigate(location)) return true;
        return `Deseja cancelar a ${projetosHibridoState?.isEdit ? 'edição' : 'criação'} do projeto?`
      }}/>

      {projetosHibridoModalsState.drawerInformacoes && (
        <InformationDrawerHibrido
          close={() => projetosHibridoActions.changeModalsValue({ drawerInformacoes: false })}
          isOpen={projetosHibridoModalsState.drawerInformacoes}
        />
    )}
    
    </>
  )    
}
